// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-up-down';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.75 7.875v9.563M9 15.188l-2.25 2.25-2.25-2.25m6.75-5.063V.562M9 2.813l2.25-2.25 2.25 2.25'
  />
);

export const viewBox = '0 0 18 18';
